import { isFolderUnderMsg } from 'owa-folders';
import { isGroupTableQuery } from 'owa-group-common';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { getStore as getListViewStore } from 'owa-mail-list-store';
import { getStore as getSearchStoreV2 } from 'owa-mail-search';
import { getStore as getSearchStoreV1 } from 'owa-mail-search-store';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import { getMailModuleStore } from 'owa-mail-store/lib/store/Store';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { compareSearchScope, primaryMailboxSearchScope } from 'owa-search-service';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getFocusedFilterForTable, getIsEverythingSelectedInTable, getSelectedTableView, } from 'owa-mail-list-store';
export var ListRestrictionType;
(function (ListRestrictionType) {
    ListRestrictionType[ListRestrictionType["Empty"] = 0] = "Empty";
    ListRestrictionType[ListRestrictionType["WithItems"] = 1] = "WithItems";
    ListRestrictionType[ListRestrictionType["WithUnreadItems"] = 2] = "WithUnreadItems";
})(ListRestrictionType || (ListRestrictionType = {}));
export var SelectionRestrictionType;
(function (SelectionRestrictionType) {
    SelectionRestrictionType[SelectionRestrictionType["HasSelection"] = 0] = "HasSelection";
    SelectionRestrictionType[SelectionRestrictionType["SelectAll"] = 1] = "SelectAll";
    SelectionRestrictionType[SelectionRestrictionType["SingleSelection"] = 2] = "SingleSelection";
    SelectionRestrictionType[SelectionRestrictionType["MultipleSelection"] = 3] = "MultipleSelection";
    SelectionRestrictionType[SelectionRestrictionType["NoSelection"] = 4] = "NoSelection";
})(SelectionRestrictionType || (SelectionRestrictionType = {}));
export var ListViewTypeRestrictionType;
(function (ListViewTypeRestrictionType) {
    ListViewTypeRestrictionType[ListViewTypeRestrictionType["Conversation"] = 1] = "Conversation";
    ListViewTypeRestrictionType[ListViewTypeRestrictionType["Message"] = 2] = "Message";
})(ListViewTypeRestrictionType || (ListViewTypeRestrictionType = {}));
export var FolderRestrictionType;
(function (FolderRestrictionType) {
    FolderRestrictionType[FolderRestrictionType["Show"] = 0] = "Show";
    FolderRestrictionType[FolderRestrictionType["Hide"] = 1] = "Hide";
})(FolderRestrictionType || (FolderRestrictionType = {}));
export var ItemPartSelectionRestrictionType;
(function (ItemPartSelectionRestrictionType) {
    ItemPartSelectionRestrictionType[ItemPartSelectionRestrictionType["HasSelection"] = 1] = "HasSelection";
    ItemPartSelectionRestrictionType[ItemPartSelectionRestrictionType["SingleSelection"] = 2] = "SingleSelection";
    ItemPartSelectionRestrictionType[ItemPartSelectionRestrictionType["MultipleSelection"] = 3] = "MultipleSelection";
    ItemPartSelectionRestrictionType[ItemPartSelectionRestrictionType["NoSelection"] = 4] = "NoSelection";
})(ItemPartSelectionRestrictionType || (ItemPartSelectionRestrictionType = {}));
export var StaticFolderSearchScopeRestrictionType;
(function (StaticFolderSearchScopeRestrictionType) {
    StaticFolderSearchScopeRestrictionType[StaticFolderSearchScopeRestrictionType["Show"] = 0] = "Show";
    StaticFolderSearchScopeRestrictionType[StaticFolderSearchScopeRestrictionType["Hide"] = 1] = "Hide";
})(StaticFolderSearchScopeRestrictionType || (StaticFolderSearchScopeRestrictionType = {}));
export var SortByRestrictionType;
(function (SortByRestrictionType) {
    SortByRestrictionType[SortByRestrictionType["Show"] = 0] = "Show";
    SortByRestrictionType[SortByRestrictionType["Hide"] = 1] = "Hide";
})(SortByRestrictionType || (SortByRestrictionType = {}));
export var ReadingPaneRestrictionType;
(function (ReadingPaneRestrictionType) {
    ReadingPaneRestrictionType[ReadingPaneRestrictionType["Hidden"] = 0] = "Hidden";
    ReadingPaneRestrictionType[ReadingPaneRestrictionType["Immersive"] = 1] = "Immersive";
    ReadingPaneRestrictionType[ReadingPaneRestrictionType["Right"] = 2] = "Right";
})(ReadingPaneRestrictionType || (ReadingPaneRestrictionType = {}));
export var TableQueryTypeRestrictionType;
(function (TableQueryTypeRestrictionType) {
    TableQueryTypeRestrictionType[TableQueryTypeRestrictionType["Hide"] = 0] = "Hide";
    TableQueryTypeRestrictionType[TableQueryTypeRestrictionType["Show"] = 1] = "Show";
})(TableQueryTypeRestrictionType || (TableQueryTypeRestrictionType = {}));
export var ShadowMailboxRestrictionType;
(function (ShadowMailboxRestrictionType) {
    ShadowMailboxRestrictionType[ShadowMailboxRestrictionType["HideForShadowMailbox"] = 1] = "HideForShadowMailbox";
    ShadowMailboxRestrictionType[ShadowMailboxRestrictionType["ShowForShadowMailbox"] = 2] = "ShowForShadowMailbox";
})(ShadowMailboxRestrictionType || (ShadowMailboxRestrictionType = {}));
export var GroupMailboxRestrictionType;
(function (GroupMailboxRestrictionType) {
    GroupMailboxRestrictionType[GroupMailboxRestrictionType["HideForGroupMailbox"] = 1] = "HideForGroupMailbox";
    GroupMailboxRestrictionType[GroupMailboxRestrictionType["ShowForGroupMailbox"] = 2] = "ShowForGroupMailbox";
})(GroupMailboxRestrictionType || (GroupMailboxRestrictionType = {}));
export var ViewFilterRestrictionType;
(function (ViewFilterRestrictionType) {
    ViewFilterRestrictionType[ViewFilterRestrictionType["Show"] = 0] = "Show";
    ViewFilterRestrictionType[ViewFilterRestrictionType["Hide"] = 1] = "Hide";
})(ViewFilterRestrictionType || (ViewFilterRestrictionType = {}));
export var MailboxType;
(function (MailboxType) {
    // VSO: 31208 - Revamp Behaviors.ts file and the logical implementation of it to use MailboxType for Groups and Shadow
    MailboxType[MailboxType["PrimaryMBX"] = 1] = "PrimaryMBX";
    MailboxType[MailboxType["ArchiveMBX"] = 2] = "ArchiveMBX";
})(MailboxType || (MailboxType = {}));
export var MailboxRestrictionType;
(function (MailboxRestrictionType) {
    MailboxRestrictionType[MailboxRestrictionType["Show"] = 1] = "Show";
    MailboxRestrictionType[MailboxRestrictionType["Hide"] = 2] = "Hide";
})(MailboxRestrictionType || (MailboxRestrictionType = {}));
export var SearchScopeRestrictionType;
(function (SearchScopeRestrictionType) {
    SearchScopeRestrictionType[SearchScopeRestrictionType["Show"] = 1] = "Show";
    SearchScopeRestrictionType[SearchScopeRestrictionType["Hide"] = 2] = "Hide";
})(SearchScopeRestrictionType || (SearchScopeRestrictionType = {}));
/**
 * Calculate the should show behavior based on a list of behaviors.
 * @param behaviors
 */
export function shouldShowMenuItem(behaviors) {
    if (behaviors === void 0) { behaviors = null; }
    return function () {
        if (!behaviors) {
            return true;
        }
        var shouldShowResult = false;
        behaviors.forEach(function (behavior) {
            shouldShowResult = shouldShowResult || shouldShowOnSingleBehavior(behavior);
        });
        return shouldShowResult;
    };
}
/**
 * Calculate the shouldShowResult based on a single list view behavior
 * @param behavior the list view behavior
 */
function shouldShowOnSingleBehavior(behavior) {
    var shouldShowResult = true;
    // Check if we are in the right folder.
    var selectedFolderId = getFolderIdForSelectedNode();
    var selectedFolderDistinguishedId = selectedFolderId && folderIdToName(selectedFolderId);
    if (behavior.foldersRestrictionList && selectedFolderDistinguishedId) {
        var isFolderInRestrictionList = behavior.foldersRestrictionList.indexOf(selectedFolderDistinguishedId) >= 0;
        switch (behavior.folderRestrictionType) {
            case 0 /* Show */: // In this case we show it only if it is in the specified list.
                shouldShowResult = shouldShowResult && isFolderInRestrictionList;
                break;
            case 1 /* Hide */: // In this case we show it only if it is NOT in the specified list.
                shouldShowResult = shouldShowResult && !isFolderInRestrictionList;
                break;
        }
    }
    var tableView = getSelectedTableView();
    if (behavior.staticFolderSearchScopeRestrictionList &&
        tableView.tableQuery.type === 1 /* Search */) {
        var staticSearchScope_1 = isMailFeatureEnabled('sea-commonSearchBox')
            ? getSearchStoreV2().staticSearchScope
            : getSearchStoreV1().staticSearchScope;
        var isStaticFolderInRestrictionList = behavior.staticFolderSearchScopeRestrictionList
            .map(function (distinguishedFolderId) {
            return primaryMailboxSearchScope({
                folderId: folderNameToId(distinguishedFolderId),
                kind: "PrimaryMailbox" /* PrimaryMailbox */,
            });
        })
            .filter(function (searchScope) { return compareSearchScope(searchScope, staticSearchScope_1); }).length >
            0;
        switch (behavior.staticFolderSearchScopeRestrictionType) {
            case 0 /* Show */: // In this case we show it only if it is in the specified list.
                shouldShowResult = shouldShowResult && isStaticFolderInRestrictionList;
                break;
            case 1 /* Hide */: // In this case we show it only if it is NOT in the specified list.
                shouldShowResult = shouldShowResult && !isStaticFolderInRestrictionList;
                break;
        }
    }
    if (behavior.searchScopeKindList && tableView.tableQuery.type == 1 /* Search */) {
        var staticSearchScope = isMailFeatureEnabled('sea-commonSearchBox')
            ? getSearchStoreV2().staticSearchScope
            : getSearchStoreV1().staticSearchScope;
        var isCurrentSearchScopeInRestriction = staticSearchScope && behavior.searchScopeKindList.indexOf(staticSearchScope.kind) > -1;
        switch (behavior.searchScopeRestrictionType) {
            case 1 /* Show */:
                shouldShowResult = shouldShowResult && isCurrentSearchScopeInRestriction;
                break;
            case 2 /* Hide */:
                shouldShowResult = shouldShowResult && !isCurrentSearchScopeInRestriction;
                break;
        }
    }
    // Check if focusedViewFilter restrictions are to be applied
    if (behavior.focusedViewFilterRestrictionList) {
        shouldShowResult =
            shouldShowResult &&
                behavior.focusedViewFilterRestrictionList.indexOf(getFocusedFilterForTable(tableView)) >= 0;
    }
    // Check if we are in the right listview selection mode.
    var selectedRowsCount = tableView.selectedRowKeys.size;
    switch (behavior.selectionRestrictionType) {
        case 4 /* NoSelection */:
            // Exclude the select all mode, because the selection is virtual and list view actually has no selected items.
            shouldShowResult =
                shouldShowResult && selectedRowsCount == 0 && !tableView.isInVirtualSelectAllMode;
            break;
        case 0 /* HasSelection */:
            shouldShowResult = shouldShowResult && selectedRowsCount > 0;
            break;
        case 1 /* SelectAll */:
            shouldShowResult = shouldShowResult && getIsEverythingSelectedInTable(tableView);
            break;
        case 2 /* SingleSelection */:
            shouldShowResult = shouldShowResult && selectedRowsCount == 1;
            break;
        case 3 /* MultipleSelection */:
            shouldShowResult = shouldShowResult && selectedRowsCount > 1;
            break;
    }
    /**
     * Before using this const, note that there are some scenarios where it
     * can be undefined, so you must check it exists before trying to access
     * any of its properties.
     *
     * Two known scenarios in which is possible include:
     *  1.) Search
     *  2.) Opening a group mailbox
     */
    var selectedFolder = getSelectedFolder();
    // Check if we have the right number of items on listview;
    switch (behavior.listRestrictionType) {
        case 0 /* Empty */:
            shouldShowResult = shouldShowResult && tableView.rowKeys.length == 0;
            break;
        case 1 /* WithItems */:
            shouldShowResult = shouldShowResult && tableView.rowKeys.length > 0;
            break;
        case 2 /* WithUnreadItems */:
            shouldShowResult = shouldShowResult && selectedFolder && selectedFolder.UnreadCount > 0;
            break;
    }
    if (typeof behavior.readingPaneRestrictionType === 'number') {
        var globalReadingPanePositionReact = getUserConfiguration().UserOptions
            .GlobalReadingPanePositionReact;
        var showReadingPane = getMailModuleStore().showReadingPane;
        switch (behavior.readingPaneRestrictionType) {
            case 1 /* Immersive */:
                shouldShowResult =
                    shouldShowResult &&
                        showReadingPane &&
                        globalReadingPanePositionReact == ReadingPanePosition.Off;
                break;
            case 2 /* Right */:
                shouldShowResult =
                    shouldShowResult && globalReadingPanePositionReact == ReadingPanePosition.Right;
                break;
            case 0 /* Hidden */:
                shouldShowResult = shouldShowResult && !showReadingPane;
                break;
        }
    }
    if (behavior.listViewTypeRestrictionType) {
        var listViewTypeReact = tableView.tableQuery.listViewType;
        switch (behavior.listViewTypeRestrictionType) {
            case 2 /* Message */:
                shouldShowResult =
                    shouldShowResult && listViewTypeReact == 1 /* Message */;
                break;
            case 1 /* Conversation */:
                shouldShowResult =
                    shouldShowResult && listViewTypeReact == 0 /* Conversation */;
                break;
        }
    }
    if (behavior.viewFilterRestrictionList) {
        var isViewFilterInRestrictionList = behavior.viewFilterRestrictionList.includes(tableView.tableQuery.viewFilter);
        switch (behavior.viewFilterRestrictionType) {
            // Show menu item only if the view filter is in the specified list.
            case 0 /* Show */:
                shouldShowResult = shouldShowResult && isViewFilterInRestrictionList;
                break;
            // Show menu item only if the view filter is not in the specified list.
            case 1 /* Hide */:
                shouldShowResult = shouldShowResult && !isViewFilterInRestrictionList;
                break;
        }
    }
    if (behavior.tableQueryTypeRestrictionList) {
        var isTableQueryInRestrictionList = behavior.tableQueryTypeRestrictionList.indexOf(tableView.tableQuery.type) >= 0;
        switch (behavior.tableQueryTypeRestrictionType) {
            case 1 /* Show */: // In this case we show it only if it is in the specified list.
                shouldShowResult = shouldShowResult && isTableQueryInRestrictionList;
                break;
            case 0 /* Hide */: // In this case we show it only if it is NOT in the specified list.
                shouldShowResult = shouldShowResult && !isTableQueryInRestrictionList;
                break;
        }
    }
    if (behavior.sortByRestrictionList) {
        var isSortByInRestrictionList = false;
        if (tableView.tableQuery.type == 0 /* Folder */ ||
            tableView.tableQuery.type == 2 /* Group */) {
            var tableSortBy = tableView.tableQuery.sortBy;
            for (var i = 0; i < behavior.sortByRestrictionList.length; i++) {
                if (behavior.sortByRestrictionList[i].sortColumn == tableSortBy.sortColumn &&
                    behavior.sortByRestrictionList[i].sortDirection == tableSortBy.sortDirection) {
                    isSortByInRestrictionList = true;
                }
            }
        }
        else {
            isSortByInRestrictionList = true;
        }
        switch (behavior.sortByRestrictionType) {
            case 0 /* Show */: // In this case we show it only if it is in the specified list.
                shouldShowResult = shouldShowResult && isSortByInRestrictionList;
                break;
            case 1 /* Hide */: // In this case we show it only if it is NOT in the specified list.
                shouldShowResult = shouldShowResult && !isSortByInRestrictionList;
                break;
        }
    }
    if (behavior.shadowMailboxRestrictionType) {
        var isUserShadowMailbox = getUserConfiguration().SessionSettings.IsShadowMailbox;
        switch (behavior.shadowMailboxRestrictionType) {
            case 1 /* HideForShadowMailbox */:
                shouldShowResult = shouldShowResult && !isUserShadowMailbox;
                break;
            case 2 /* ShowForShadowMailbox */:
                shouldShowResult = shouldShowResult && isUserShadowMailbox;
                break;
        }
    }
    if (behavior.groupMailboxRestrictionType) {
        var isGroupMailbox = isGroupTableQuery(tableView.tableQuery);
        switch (behavior.groupMailboxRestrictionType) {
            case 1 /* HideForGroupMailbox */:
                shouldShowResult = shouldShowResult && !isGroupMailbox;
                break;
            case 2 /* ShowForGroupMailbox */:
                shouldShowResult = shouldShowResult && isGroupMailbox;
                break;
        }
    }
    if (behavior.itemPartSelectionRestrictionType) {
        var numItemPartsSelected = getListViewStore().expandedConversationViewState
            .selectedNodeIds.length;
        var hasItemPartsSelected = !tableView.isInCheckedMode && numItemPartsSelected > 0;
        switch (behavior.itemPartSelectionRestrictionType) {
            case 4 /* NoSelection */:
                shouldShowResult = shouldShowResult && !hasItemPartsSelected;
                break;
            case 1 /* HasSelection */:
                shouldShowResult = shouldShowResult && hasItemPartsSelected;
                break;
            case 2 /* SingleSelection */:
                shouldShowResult =
                    shouldShowResult && !tableView.isInCheckedMode && numItemPartsSelected == 1;
                break;
            case 3 /* MultipleSelection */:
                shouldShowResult =
                    shouldShowResult && !tableView.isInCheckedMode && numItemPartsSelected > 1;
        }
    }
    // This restriction is dependent on the type of mailbox
    // mailboxType and mailboxRestrictionType always go together otherwise no restriction is to be put
    if (behavior.mailboxType && behavior.mailboxRestrictionType) {
        var isMbxScenario = isMailboxScenario(behavior.mailboxType, selectedFolder, tableView.tableQuery.folderId);
        switch (behavior.mailboxRestrictionType) {
            case 1 /* Show */:
                shouldShowResult = shouldShowResult && isMbxScenario;
                break;
            case 2 /* Hide */:
                shouldShowResult = shouldShowResult && !isMbxScenario;
                break;
        }
    }
    // This restriction is based on the tree type of the folder
    if (behavior.folderTreeTypeRestrictionList && selectedFolder) {
        var selectedFolderTreeType = selectedFolder.treeType;
        var isFolderInRestrictionList = behavior.folderTreeTypeRestrictionList.indexOf(selectedFolderTreeType) >= 0;
        switch (behavior.mailboxRestrictionType) {
            case 1 /* Show */:
                shouldShowResult = shouldShowResult && isFolderInRestrictionList;
                break;
            case 2 /* Hide */:
                shouldShowResult = shouldShowResult && !isFolderInRestrictionList;
                break;
        }
    }
    // Check if there is any custom restriction specified
    if (behavior.customRestriction) {
        shouldShowResult =
            shouldShowResult && behavior.customRestriction(selectedFolderDistinguishedId);
    }
    return shouldShowResult;
}
/**
 * Calculates whether user's state is in a given mailbox type
 */
function isMailboxScenario(mailboxType, selectedFolder, folderId) {
    switch (mailboxType) {
        case 1 /* PrimaryMBX */:
            return isFolderUnderMsg(selectedFolder);
        case 2 /* ArchiveMBX */:
            return isFolderUnderArchiveRoot(folderId);
    }
}
//# sourceMappingURL=Behaviors.js.map